import {
  careplanProductCartClickedSchema,
  careplanProductWhyRecommendedViewedSchema,
  cartLineQuantityChangedSchema,
  cartLineRestoredSchema,
  flowFinalizedSchema,
  flowLoadedSchema,
  postPurchaseRecommendationsUpsellProductViewedSchema,
  stepCompletedSchema,
} from "@/config/analytics/schemas";

export const eventNameToPayloadSchema = {
  cart_checkout_started: undefined,
  cart_line_quantity_changed: cartLineQuantityChangedSchema,
  cart_line_restored: cartLineRestoredSchema,
  careplan_sticky_checkout_clicked: undefined,
  careplan_product_view_cart_clicked: careplanProductCartClickedSchema,
  careplan_product_add_to_cart_clicked: careplanProductCartClickedSchema,
  careplan_summary_details_clicked: undefined,
  careplan_summary_view_cart_clicked: undefined,
  flow_loaded: flowLoadedSchema,
  flow_finalized: flowFinalizedSchema,
  product_why_recommended_viewed: careplanProductWhyRecommendedViewedSchema,
  post_purchase_subscribe_started: undefined,
  post_purchase_reorder_started: undefined,
  post_purchase_all_products_viewed: undefined,
  post_purchase_upsell_product_viewed: postPurchaseRecommendationsUpsellProductViewedSchema,
  post_purchase_upsell_careplan_viewed: undefined,
  step_completed: stepCompletedSchema,
} as const;

export const SENSITIVE_WORDS = ["THC", "CBD", "cannabis", "canabis", "marihuana", "marijuana"]; // cspell:disable-line
